import { ColumnViewModel } from '../../shared/column-types';

export const DISEASES_ALL: ColumnViewModel = {
  columns: [
    'name',
    'diseaseUMLSCUI',
    'type',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'nct_id',
    'numCTs',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'numChemicals',
    'numPublications',
    'numPublications_GDA',
    'numPublications_VDA',
    'firstRef',
    'lastRef',
    'prevalence',
    'disease_inheritance',
  ],
  defaultVisible: [
    'name',
    'type',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'numCTs',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'numPublications_GDA',
    'numPublications_VDA',
    'firstRef',
    'lastRef',
  ],
};